const MellonWebECRIntentStatus = Object.freeze({
    PENDING: 1,
    SENT: 2,
    COMPLETED: 3,
});

module.exports = MellonWebECRIntentStatus;
